import React,{useState} from 'react';
import { Link } from 'react-router-dom';
import { Shield, CheckCircle, User, Target, BarChart } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faClipboardList, faChartLine, faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { FaPhone } from "react-icons/fa6"
import { IoMdMail } from "react-icons/io";
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaMapMarkerAlt } from 'react-icons/fa';
import { BsLinkedin } from "react-icons/bs"
// import { useSelector } from 'react-redux'; 


const LandingPage = () => {
    // const { isAuthenticated, user } = useAuth(); // Replaced with useSelector
    // const isAuthenticated = useSelector((state) => state.auth.token);
    // const user = useSelector((state) => state.auth.user);

    // const getDashboardLink = () => {
    //     if (!user) return '/login';
    //     return user.role === 'admin' ? '/admin/dashboard' : '/employee/dashboard';
    // };
    const [contactForm, setContactForm] = useState({
      name: "",
      email: "",
      message: "",
    });
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      try {
        const res = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // access_key: accessKey,
            name: contactForm.name,
            email: contactForm.email,
            message: contactForm.message,
            subject: "New Contact Form Submission on Online-Permit",
          }),
        });
  
        const result = await res.json();
        console.log("Web3Forms response:", result);
  
        if (result.success) {
          alert("Message sent successfully!");
          setContactForm({ name: "", email: "", message: "" });
        } else {
          alert("Failed to send message.");
        }
      } catch (error) {
        console.error("Error sending message:", error);
        alert("Something went wrong. Please try again.");
      }
    };
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setContactForm(prev => ({ ...prev, [name]: value }));
    };


    return (
        <div className="min-h-screen bg-white">
            {/* Header */}
            {/* <header className="bg-white shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16 items-center">
                        <div className="flex items-center">
                            <Shield className="h-8 w-8 text-blue-600" />
                            <span className="ml-2 text-xl font-bold text-gray-900">SafetyGuard</span>
                        </div>
                        <div>
                            {isAuthenticated ? (
                                <Link
                                    to={getDashboardLink()}
                                    className="btn btn-primary"
                                >
                                    Go to Dashboard
                                </Link>
                            ) : (
                                <div className="space-x-4">
                                    <Link
                                        to="/login"
                                        className="btn btn-secondary"
                                    >
                                        Log In
                                    </Link>
                                    <Link
                                        to="/signup"
                                        className="btn btn-primary"
                                    >
                                        Sign Up
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header> */}

            {/* Hero Section */}
            <div className=" bg-blue-700 overflow-hidden">
                <div className="max-w-7xl mx-auto">
                    <div className="relative z-10 pb-8 bg-blue-700 sm:pb-16 md:pb-20 lg:w-full lg:pb-28 xl:pb-32">
                        <div className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
                            <div className="text-center sm:text-left">
                                <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl">
                                    <span className="block">Behaviour-Based</span>
                                    <span className="block text-blue-400">Safety System</span>
                                </h1>
                                <p className="mt-3 text-base text-blue-200 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                                    Track safety observations, assign corrective actions, and build a culture of safety in your organization.
                                </p>
                                <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                                    <div className="rounded-md shadow">
                                        <Link
                                            to="/signup"
                                            className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg md:px-10"
                                        >
                                            Get Started
                                        </Link>
                                    </div>
                                    <div className="mt-3 sm:mt-0 sm:ml-3">
                                        <Link
                                            to="/login"
                                            className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200 md:py-4 md:text-lg md:px-10"
                                        >
                                            Log In
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Features Section */}
            <div className="py-12 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="lg:text-center">
                        <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">Features</h2>
                        <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                            A better way to ensure safety
                        </p>
                        <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                            Our comprehensive system helps you track, manage, and improve safety across your organization.
                        </p>
                    </div>

                    <div className="mt-10">
                        <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                                        <CheckCircle className="h-6 w-6" />
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">Observation Tracking</h3>
                                    <p className="mt-2 text-base text-gray-500">
                                        Record both safe and at-risk behaviors to identify patterns and improvement areas.
                                    </p>
                                </div>
                            </div>

                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                                        <User className="h-6 w-6" />
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">Role-Based Access</h3>
                                    <p className="mt-2 text-base text-gray-500">
                                        Admin and Employee roles with appropriate permissions for managing the system.
                                    </p>
                                </div>
                            </div>

                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                                        <Target className="h-6 w-6" />
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">Action Management</h3>
                                    <p className="mt-2 text-base text-gray-500">
                                        Assign, track, and review corrective actions to close the safety loop.
                                    </p>
                                </div>
                            </div>

                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                                        <BarChart className="h-6 w-6" />
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">Dashboards & Analytics</h3>
                                    <p className="mt-2 text-base text-gray-500">
                                        Visualize safety data and track trends to drive continuous improvement.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="bg-blue-700">
                <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
                    <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                        <span className="block">Ready to improve safety?</span>
                        <span className="block text-blue-300">Start using SafetyGuard today.</span>
                    </h2>
                    <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
                        <div className="inline-flex rounded-md shadow">
                            <Link
                                to="/signup"
                                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
                            >
                                Get Started
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Form */}
<section
      className="py-20 bg-gradient-to-br from-blue-50 via-white to-indigo-50"
      id="Contact"
    >
      <div className="container mx-auto px-6" id="contact">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
          Get in Touch
        </h2>
        <div className="max-w-3xl mx-auto">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={contactForm.name}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={contactForm.email}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                value={contactForm.message}
                onChange={handleInputChange}
                rows={4}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-medium transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/30"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Behaviour-Based Safety System </h3>
            <p className="text-gray-400">
            Track safety observations, assign corrective actions, and build a culture of safety in your organization.
            </p>
            <div className="flex space-x-4 mt-4 justify-center">
              <a
                href="https://in.linkedin.com/company/thesafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 hover:text-blue-800 transition-colors"
              >
                <BsLinkedin className="w-6 h-6" />
              </a>

              <a
                href="https://www.facebook.com/thesafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-700 transition-colors"
              >
                <FaFacebook className="w-6 h-6" />
              </a>

              <a
                href="https://twitter.com/thsafetymaster"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#ffffff] hover:text-[#daf1ff] transition-colors"
              >
                <FaXTwitter className="w-6 h-6" />
              </a>  

              <a
                href="https://www.youtube.com/channel/UCfBqBnuUfcMlORvhBaft7yA"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#f14d4d] hover:text-red-800 transition-colors"
              >
                <FaYoutube className="w-6 h-6" />
              </a>  

              <a
                href="https://api.whatsapp.com/send/?phone=917665231743&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#40db62] hover:text-green-800 transition-colors"
              >
                <FaWhatsapp className="w-6 h-6" />
              </a>  
              <a
                href="https://www.instagram.com/thesafetymaster_tsm/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink-700 hover:text-pink-800 transition-colors"
              >
                <FaInstagram className="w-6 h-6" />
              </a>  



              <a
                href="info@thesafetymaster.com"
                className="text-[#D44638] hover:text-red-600 transition-colors"
              >
                {/* <Mail className="w-6 h-6" /> */}
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a
                   href="#home"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#features"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                 href="#work"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  How it Works
                </a>
              </li>
              <li>
                <a
                  href="#Contact"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className='flex flex-col '>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <a href="mailto:info@thesafetymaster.com" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <IoMdMail className="w-4 h-5 mr-2 text-white" />
            <p>info@thesafetymaster.com</p>
          </a>
              <a href="tel:+917665231743" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <FaPhone className="w-3 h-4 mr-2 text-white" />
            <p>+91 7665231743</p>
          </a>
           {/* Phone Number 2 */}
           <a href="tel:+919413882016" className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500">
            <FaPhone className="w-3 h-4 mr-2 text-white" />
            <p>+91 9413882016</p>
          </a>
          {/* Address */}
         <a
          href="https://www.google.com/maps/search/?q=Unit+No+221,+Sunsquare+Plaza+Complex,+2nd+%26+4th+Floor,+450-451-452,+SPL1%2FJ,+RIICO+Chowk,+Bhiwadi,+Rajasthan+301019"
        target="_blank"
        rel="noopener noreferrer"
         className="flex items-center text-gray-400 cursor-pointer hover:text-blue-500 mt-4"
       >
    <FaMapMarkerAlt className="w-8 h-10 mr-2 text-white" />
    <p>Unit No 221-445-450-451-452-453, 2nd & 4th Floor, Sunsquare Plaza Complex, RIICO Chowk, Bhiwadi, Rajasthan 301019</p>
  </a>
            </div>
          <div>
            <h4 className="text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://www.thesafetymaster.com/privacy-policy/"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
            <p className="text-gray-400 mt-4">
              &copy; {new Date().getFullYear()} TSM Digitech. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
    </div>
  );
}


export default LandingPage;